import { render } from "./HomepageSectionDetailView.vue?vue&type=template&id=236dd2ac&scoped=true"
import script from "./HomepageSectionDetailView.vue?vue&type=script&lang=js"
export * from "./HomepageSectionDetailView.vue?vue&type=script&lang=js"

import "./HomepageSectionDetailView.vue?vue&type=style&index=0&id=236dd2ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236dd2ac"]])

export default __exports__